import { httpCreate } from './http';

const http = httpCreate('/srv/watch-list');

// 新版观看列表内容由mysql => mongoDB 直播间内更具newMark进行判断
export const watchList = {
	// 观看列表(新版)
	getWatchList(activityId, params) {
		return http.get(`/${activityId}`, { params });
	},
	// 获取观众总观看时长
	getTotalOnlineTime(activityId) {
		return http.get(`/totalOnlineTime/${activityId}`);
	},
	// 用户管理获取观看信息
	userInfo(userId) {
		return http.get(`/userManage/total/${userId}`);
	},
	// 用户管理获取观看记录列表
	umWatchList(userId, params) {
		return http.get(`/userManage/pageList/${userId}`, { params });
	},
};
